import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _Agency, _AirLine, _Airport, _CommercialCampaign, _CustomerAddress, _ImpTransportDestination, _TransportDestination } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { FileInput } from "../../../theme/Component/FileInput";
import { CitiesEditor } from "../Countries/Cities/CitiesEditor";


export const TransportDestination = () => {

    const transdest = useDataBean(_TransportDestination);
    const imptransp = useDataBean(_ImpTransportDestination);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaladd, setModaladd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        transdest.instance.getTransportDestinationCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)

                }
            }
        )

    }
    const importTransportDestination = () => {
        //console.log(entailment.bean);
        imptransp.instance.importTransportDestination(imptransp.bean.Media, imptransp.bean.MediaContext, null).then(
            (resp: any) => {
                // getLista();
                setModaladd({ ...modaladd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        transdest.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        transdest.instance.deleteTransportDestination(transdest.bean.IDTransportDestination).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        transdest.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const veradd = () => {
        setModaladd({ ...modaladd, "view": true });

    }
    const head = [
        { title: 'ID', property: 'IDTransportDestination', visible: true },
        { title: 'Ciudad', property: 'SiteIDName', visible: true },
        { title: 'Código IATA', property: 'IATACode', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Habilitada', property: 'Enabled', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Destinos de Transporte">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={veradd}>
                        Importar Destinos
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={transdest.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <CitiesEditor render={transdest.bean.SiteIDName} idSelector={transdest.bean.IDCities} onChange={(e) => { transdest.setBean({ ...transdest.bean, "IDCities": e.IDCities, "SiteIDName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Habilitada" estado={transdest.bean.Enabled} eventChange={(e: any) => { transdest.setBean({ ...transdest.bean, "Enabled": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Código IATA</label>
                                <textarea name="IATACode" className="form-control" value={transdest.bean.IATACode} onChange={(e: any) => { transdest.setBean({ ...transdest.bean, "IATACode": e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={transdest.bean.Description} onChange={transdest.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaladd} updateModal={setModaladd} eventModal={importTransportDestination}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <FileInput
                                        Media={imptransp.bean.Media}
                                        MediaContext={imptransp.bean.MediaContext}
                                        directory='transporte'
                                        label='Archivo'
                                        docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                        onCreate={(Filemap: any) => { imptransp.setBean({ ...imptransp.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                    ></FileInput>
                                </div>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {transdest.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}